export const promos = [
{
idPromo: '-N6t-UoiF78UD6S1I4Vw',
imagePromo: 'https://firebasestorage.googleapis.com/v0/b/project-4616920480246266429.appspot.com/o/promocao%2Fstorage%3A-N6t-UoiF78UD6S1I4Vw%3Athumbnail%3A1659358538510?alt=media&token=4c7bc721-4ac3-4d74-ae00-9b483ef56982',
titlePromo: 'Cuscuzlícia Sabores do Nordeste - Sobremesa Grátis 🧁',
descriptionPromo: `
Consumindo R$70,00 ou mais você ganha uma cocada cremosa de milho ou um mungunzá, pegue seu cupom e apresente!

#triibo_proximas
#club_alimentacao
`,
textShare: `
*Campanha:*
Final de Ano Maluco

*Estabelecimento Triibo:* 
Cuscuzlícia Sabores do Nordeste

*Promoção:*
Sobremesa Grátis 🧁

Clique no link para participar da promoção: 
`
},

{
idPromo: '-MLxHW_b6bODmKaJG7We',
imagePromo: 'https://firebasestorage.googleapis.com/v0/b/project-4616920480246266429.appspot.com/o/promocao%2Fstorage%3A-MLxHW_b6bODmKaJG7We%3Athumbnail%3A1605198854702?alt=media&token=abfcaeb5-2a23-495a-8b2e-ba71e1ce8759',
titlePromo: 'Nati Gentil | Doces Gourmet - Junte e Ganhe✨',
descriptionPromo: `
Cliente especial Sempre Ganha! A Nati Gentil tem uma promoção especial para você, a cada 10 reais em compras escaneie a promoção no crachá do atendente para ganhar 01 cupom, junte 10 cupons e após a validação no local ganhe 01 brigadeiro e 01 café coado. Aproveite.

#triibo_proximas
#vlc_promos
`,
textShare: `
*Campanha:*
Final de Ano Maluco

*Estabelecimento Triibo:* 
Nati Gentil | Doces Gourmet

*Promoção:*
Junte e Ganhe✨

Clique no link para participar da promoção: 
`
},

{
idPromo: '-NBCjTxN-FmR4fbvCxs2',
imagePromo: 'https://firebasestorage.googleapis.com/v0/b/project-4616920480246266429.appspot.com/o/promocao%2Fstorage%3A-NBCjTxN-FmR4fbvCxs2%3Athumbnail%3A1662382894899?alt=media&token=38fad1d1-2ae5-4484-a7fc-46c9278287d2',
titlePromo: 'FD Studio Cabeleireiros - FAÇA PÉ e Mão e GANHE Escova',
descriptionPromo: `
Aproveite a parceria FD Studio Cabelereiros e Club MAPFRE!

O Salão de Beleza FD Studio criou uma promoção imperdível para sócios Club MAPFRE.

FAÇA e GANHE – Faça PÉ e Mão e GANHE Escova

Válido de terça à quinta-feira, das 9h às 18hr.
1 cupom por sócio Club MAPFRE*
Apresente o QR Code no estabelecimento

Agende seu horário e aproveite (11) 99687-3883

#triibo_proximas
#club_belezaesaude
#qr_exclusivo
`,
textShare: `
*Campanha:*
Final de Ano Maluco

*Estabelecimento Triibo:* 
FD Studio Cabeleireiros

*Promoção:*
FAÇA PÉ e Mão e GANHE Escova

Clique no link para participar da promoção: 
`
},

{
idPromo: '-Mgps051SbfqgI-_d8oE',
imagePromo: 'https://firebasestorage.googleapis.com/v0/b/project-4616920480246266429.appspot.com/o/promocao%2Fstorage%3A-Mgps051SbfqgI-_d8oE%3Athumbnail%3A1628696474206?alt=media&token=ddb48f2c-6f32-4e35-b96f-ec15ce7a2b23',
titlePromo: 'Thiago Tattoo Studio - 3 Tatuagens de 5cm por $100,00',
descriptionPromo: `
Aproveite a promoção que o Thiago Tatto oferece para você! Faça 3 tatuagens de 5cm em preto por $100,00 traga sua ideia e aproveite, válida nos dias de segunda, terça, quarta e sábado. Escanei o QR code no display ou no crachá do estabelecimento para validar um cupom e ganhar o desconto.

*O resgate desta promoção é pessoal e intransferível.
*Promoção válida de acordo com as condições informadas acima.
*Sujeito a alterações sem aviso prévio.

#triibo_proximas
`,
textShare: `
*Campanha:*
Final de Ano Maluco

*Estabelecimento Triibo:* 
Thiago Tattoo Studio

*Promoção:*
3 Tatuagens de 5cm por $100,00

Clique no link para participar da promoção: 
`
},

{
idPromo: '-McuSMPThACO3j31XOza',
imagePromo: 'https://firebasestorage.googleapis.com/v0/b/project-4616920480246266429.appspot.com/o/promocao%2Fstorage%3A-NFjX8x7EoocOAqvGcbk%3Athumbnail%3A1667245213266?alt=media&token=6ae48ecd-7b1d-4ccc-8d74-70f5a30e9137',
titlePromo: 'Marketplace Triibo - 6% OFF - Joelho Suíno Defumado 1.400g a 1.700Kg – Charcutaria Artesanal',
descriptionPromo: `
O joelho de porco é um substancioso prato dos mais famosos da culinária alemã (onde é chamado de eisbein), que se tornou popular no Brasil. Nome e modo de preparo variam de região para região, e a carne é geralmente servida com chucrute. Sabor suave e suculento, pronto para consumir como aperitivo ou em uma refeição.

Aproveite!

#promocoes_marketplace
`,
textShare: `
*Campanha:*
Final de Ano Maluco

*Estabelecimento Triibo:* 
Marketplace Triibo

*Promoção:*
6% OFF - Joelho Suíno Defumado 1.400g a 1.700Kg – Charcutaria Artesanal

Clique no link para participar da promoção: 
`
}
];